import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchReceivedInvitations } from '../../actions/reduxActions/organizations';
import CurrentTenantInviteList from './CurrentTenantInviteList';
import CurrentUserInviteList from './CurrentUserInviteList';

const Invitations = ({ currentUser, invitations, fetchInvitations }) => {

    useEffect(() => {
        fetchInvitations();
    }, []);

    return (
        <>
            <CurrentTenantInviteList invitations={invitations} currentUser={currentUser} />
            <CurrentUserInviteList invitations={invitations} currentUser={currentUser} />
        </>
    );

};

const mapStateToProps = state => ({
    invitations: state.organizationInvitations,
});


const mapDispatchToProps = {
    fetchInvitations: fetchReceivedInvitations,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Invitations);
